import React from 'react';
import { StarIcon, ShieldCheckIcon, AwardIcon, CheckCircleIcon, BuildingIcon } from 'lucide-react';
export function TrustBar() {
  const trustItems = [{
    icon: <StarIcon className="h-6 w-6 text-amber-500 fill-amber-500" data-id="element-312" />,
    text: 'Google 4.9★'
  }, {
    icon: <ShieldCheckIcon className="h-6 w-6 text-slate-700" data-id="element-313" />,
    text: 'BBB Accredited'
  }, {
    icon: <AwardIcon className="h-6 w-6 text-slate-700" data-id="element-314" />,
    text: 'GAF Certified'
  }, {
    icon: <CheckCircleIcon className="h-6 w-6 text-slate-700" data-id="element-315" />,
    text: 'Owens Corning Preferred'
  }, {
    icon: <BuildingIcon className="h-6 w-6 text-slate-700" data-id="element-316" />,
    text: 'NRCA Member'
  }, {
    icon: <ShieldCheckIcon className="h-6 w-6 text-slate-700" data-id="element-317" />,
    text: 'Licensed & Insured'
  }];
  // Duplicate items for seamless marquee effect
  const marqueeItems = [...trustItems, ...trustItems];
  return <div className="bg-muted py-8 overflow-hidden border-y border-border" data-id="element-318">
      <div className="relative flex overflow-x-hidden" data-id="element-319">
        <div className="animate-marquee whitespace-nowrap flex items-center gap-16 px-8" data-id="element-320">
          {marqueeItems.map((item, index) => <div key={index} className="flex items-center gap-3 opacity-70 hover:opacity-100 transition-opacity cursor-default" data-id="element-321">
              {item.icon}
              <span className="text-lg font-semibold text-slate-700" data-id="element-322">
                {item.text}
              </span>
            </div>)}
        </div>
        {/* We add a second identical div to ensure smooth infinite scrolling */}
        <div className="absolute top-0 animate-marquee2 whitespace-nowrap flex items-center gap-16 px-8" data-id="element-323">
          {marqueeItems.map((item, index) => <div key={`dup-${index}`} className="flex items-center gap-3 opacity-70 hover:opacity-100 transition-opacity cursor-default" data-id="element-324">
              {item.icon}
              <span className="text-lg font-semibold text-slate-700" data-id="element-325">
                {item.text}
              </span>
            </div>)}
        </div>
      </div>

      {/* Add these custom animations to index.css or tailwind config later, but inline styles for now to ensure it works */}
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-100%); }
        }
        @keyframes marquee2 {
          0% { transform: translateX(100%); }
          100% { transform: translateX(0%); }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
        .animate-marquee2 {
          animation: marquee2 30s linear infinite;
        }
      `
    }} data-id="element-326" />
    </div>;
}